import { type SxProps, type Theme } from '@mui/material';
import {
  covElevatedSurfaceBase,
  covWidePageContent,
} from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';

export const supervisorAdministrationStyles = {
  pageContent: covWidePageContent,
  pageDivider: (theme: Theme) => ({
    mb: { xs: theme.spacing(3), sm: theme.spacing(4) },
  }),
  emptyPaper: (theme: Theme) => ({
    ...covElevatedSurfaceBase(theme),
    p: { xs: theme.spacing(3), sm: theme.spacing(4) },
    border: '1px dashed #c6d4e1',
    textAlign: 'center',
  }),
  card: (theme: Theme) => ({
    ...covElevatedSurfaceBase(theme),
    height: '100%',
  }),
  cardHeader: (theme: Theme) => ({
    pb: theme.spacing(1),
    '& .MuiCardHeader-content': {
      minWidth: 0,
    },
  }),
  cardSubtitle: (theme: Theme) => ({
    mt: theme.spacing(0.5),
  }),
  cardContent: (theme: Theme) => ({
    pt: theme.spacing(0),
  }),
  chips: (theme: Theme) => ({
    minHeight: 76,
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignContent: 'flex-start',
    mb: theme.spacing(2),
  }),
  chip: (theme: Theme) => ({
    maxWidth: '100%',
    borderRadius: theme.spacing(1),
    backgroundColor: '#ffffff',
    '& .MuiChip-label': {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '&.MuiChip-outlined': {
      backgroundColor: '#ffffff',
    },
    '&.MuiChip-colorPrimary': {
      backgroundColor: '#ffffff',
    },
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  }),
  emptyText: (theme: Theme) => ({
    py: theme.spacing(2),
  }),
  inputRow: (theme: Theme) => ({
    alignItems: 'flex-start',
    pt: theme.spacing(2),
    columnGap: theme.spacing(1),
  }),
  inputBox: {
    flex: 1,
    minWidth: 0,
  } as SxProps<Theme>,
  addBtnBox: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    pt: theme.spacing(2),
  }),
  addBtn: {
    alignSelf: 'center',
  } as SxProps<Theme>,
} as const;
